import {
  setDevicesData,
  setMoveToSite,
  setReMoveFromSite,
  setDeleteDevice,
  setDevicesInventoryData,
  setDrawerContentData
} from "stores/slice/bogus/devices/const";

import {
  setDrawerDevicesData,
  setDeviceTagData,
  setEditDeviceTagData,
  setDeleteDeviceTagData
} from "stores/slice/bogus/devices/drawerContent/const";

const devicesConfig = {
  // org get devices
  // API/gluon/organizations => /ents/{entId}/orgs/{orgId}/devices
  "/ents/:entId/orgs/:orgId/devices.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/devices",
    restful: true,
    method: "read",
    buildParams: (params) => ({ data: { filter: params } }),
    action: setDevicesData,
    mockSelector: "devices.selecterDevicesData",
  },
  // API/gluon/organizations => /orgs/{orgId}/devices (standalone)
  "/orgs/:orgId/devices.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/devices",
    restful: true,
    method: "read",
    buildParams: (params) => ({ data: { filter: params } }),
    action: setDevicesData,
    mockSelector: "devices.selecterDevicesData",
  },
  // sites get devices
  // API/gluon/sites => /ents/{entId}/orgs/{orgId}/sites/{siteId}/devices
  "/ents/:entId/orgs/:orgId/sites/:siteId/devices.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/devices",
    restful: true,
    method: "read",
    buildParams: (params) => ({ data: { filter: params } }),
    action: setDevicesData,
    mockSelector: "devices.selecterDevicesData",
  },
  // API/gluon/sites => /orgs/{orgId}/sites/{siteId}/devices (standalone)
  "/orgs/:orgId/sites/:siteId/devices.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/devices",
    restful: true,
    method: "read",
    buildParams: (params) => ({ data: { filter: params } }),
    action: setDevicesData,
    mockSelector: "devices.selecterDevicesData",
  },
  // org move to site
  // API/gluon/organizations => /ents/{entId}/orgs/{orgId}/devices/assignSite
  "/ents/:entId/orgs/:orgId/devices/assignSite.update": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/devices/assignSite",
    restful: true,
    method: "update",
    buildParams: ({ siteId, deviceIds }) => ({ data: { siteId, deviceIds } }),
    action: setMoveToSite,
    mockSelector: "devices.selecterDevicesData",
  },
  // API/gluon/organizations => /orgs/{orgId}/devices/assignSite (standalone)
  "/orgs/:orgId/devices/assignSite.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/devices/assignSite",
    restful: true,
    method: "update",
    buildParams: ({ siteId, deviceIds }) => ({ data: { siteId, deviceIds } }),
    action: setMoveToSite,
    mockSelector: "devices.selecterDevicesData",
  },
  // org remove from site
  // API/gluon/organizations => /ents/{entId}/orgs/{orgId}/devices/moveToInventory
  "/ents/:entId/orgs/:orgId/devices/moveToInventory.update": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/devices/moveToInventory",
    restful: true,
    method: "update",
    buildParams: ({ data }) => ({ data }),
    action: setReMoveFromSite,
    mockSelector: "devices.selecterDevicesData",
  },
  // API/gluon/organizations => /orgs/{orgId}/devices/moveToInventory (standalone)
  "/orgs/:orgId/devices/moveToInventory.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/devices/moveToInventory",
    restful: true,
    method: "update",
    buildParams: ({ data }) => ({ data }),
    action: setReMoveFromSite,
    mockSelector: "devices.selecterDevicesData",
  },
  // sites remove from site
  // API/gluon/sites => /ents/{entId}/orgs/{orgId}/sites/{siteId}/devices/moveToInventory
  "/ents/:entId/orgs/:orgId/sites/:siteId/devices/moveToInventory.update": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/devices/moveToInventory",
    restful: true,
    method: "update",
    buildParams: ({ data }) => ({ data }),
    action: setReMoveFromSite,
    mockSelector: "devices.selecterDevicesData",
  },
  // API/gluon/sites => /orgs/{orgId}/sites/{siteId}/devices/moveToInventory (standalone)
  "/orgs/:orgId/sites/:siteId/devices/moveToInventory.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/devices/moveToInventory",
    restful: true,
    method: "update",
    buildParams: ({ data }) => ({ data }),
    action: setReMoveFromSite,
    mockSelector: "devices.selecterDevicesData",
  },
  // org delete device
  // API/gluon/organizations => /ents/{entId}/orgs/{orgId}/devices/remove
  "/ents/:entId/orgs/:orgId/devices/remove.update": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/devices/remove",
    restful: true,
    method: "update",
    buildParams: ({ data }) => ({ data }),
    action: setDeleteDevice,
    mockSelector: "devices.selecterDevicesData",
  },
  // API/gluon/organizations => /orgs/{orgId}/devices/remove (standalone)
  "/orgs/:orgId/devices/remove.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/devices/remove",
    restful: true,
    method: "update",
    buildParams: ({ data }) => ({ data }),
    action: setDeleteDevice,
    mockSelector: "devices.selecterDevicesData",
  },
  // API/gluon/organizations => API/gluon/ents/{entId}/orgs/{orgId}/devices/inventory
  "/ents/:entId/orgs/:orgId/devices/inventory.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/devices/inventory",
    restful: true,
    method: "read",
    buildParams: null,
    action: setDevicesInventoryData,
    mockSelector: "devices.selecterDevicesData",
  },
  // API/gluon/organizations => API/gluon/orgs/{orgId}/devices/inventory
  "/orgs/:orgId/devices/inventory.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/devices/inventory",
    restful: true,
    method: "read",
    buildParams: null,
    action: setDevicesInventoryData,
    mockSelector: "devices.selecterDevicesData",
  },
  // API/gluon/sites => API/gluon/ents/{entId}/orgs/{orgId}/sites/{siteId}/devices/inventory
  "/ents/:entId/orgs/:orgId/sites/:siteId/devices/inventory.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/devices/inventory",
    restful: true,
    method: "read",
    buildParams: null,
    action: setDevicesInventoryData,
    mockSelector: "devices.selecterDevicesData",
  },
  // API/gluon/sites => API/gluon/orgs/{orgId}/sites/{siteId}/devices/inventory
  "/orgs/:orgId/sites/:siteId/devices/inventory.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/devices/inventory",
    restful: true,
    method: "read",
    buildParams: null,
    action: setDevicesInventoryData,
    mockSelector: "devices.selecterDevicesData",
  },
  // API/gluon/sites => /ents/{entId}/orgs/{orgId}/sites/{siteId}/devices/addFromInventory
  "/ents/:entId/orgs/:orgId/sites/:siteId/devices/addFromInventory.update": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/devices/addFromInventory",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: setMoveToSite,
    mockSelector: "",
  },
  // API/gluon/sites => /ents/{entId}/orgs/{orgId}/sites/{siteId}/devices/addFromInventory
  "/orgs/:orgId/sites/:siteId/devices/addFromInventory.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/devices/addFromInventory",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: setMoveToSite,
    mockSelector: "",
  },
  // org drawer content
  // API/gluon/organizations => /ents/{entId}/orgs/{orgId}/devices/{deviceId}/status
  "/ents/:entId/orgs/:orgId/devices/:deviceId/status.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/devices/:deviceId/status",
    restful: true,
    method: "read",
    buildParams: null,
    action: setDrawerContentData,
    mockSelector: "devices.selecterDevicesDrawerData",
  },
  // API/gluon/organizations => /orgs/{orgId}/devices/{deviceId}/status (standalone)
  "/orgs/:orgId/devices/:deviceId/status.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/devices/:deviceId/status",
    restful: true,
    method: "read",
    buildParams: null,
    action: setDrawerContentData,
    mockSelector: "devices.selecterDevicesDrawerData",
  },
  // API/gluon/sites => /ents/{entId}/orgs/{orgId}/sites/{siteId}/devices/{deviceId}/status
  "/ents/:entId/orgs/:orgId/sites/:siteId/devices/:deviceId/status.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/devices/:deviceId/status",
    restful: true,
    method: "read",
    buildParams: null,
    action: setDrawerContentData,
    mockSelector: "devices.selecterDevicesDrawerData",
  },
  // API/gluon/sites => /orgs/{orgId}/sites/{siteId}/devices/{deviceId}/status (standalone)
  "/orgs/:orgId/sites/:siteId/devices/:deviceId/status.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/devices/:deviceId/status",
    restful: true,
    method: "read",
    buildParams: null,
    action: setDrawerContentData,
    mockSelector: "devices.selecterDevicesDrawerData",
  },
  // API/gluon/sites => /ents/{entId}/orgs/{orgId}/sites/{siteId}/settings/deviceAccount
  "/ents/:entId/orgs/:orgId/sites/:siteId/devices/inventoryDeviceAccount.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/devices/inventoryDeviceAccount",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "addDeviceInventoryDeviceAccount",
  },
  // API/gluon/sites => /orgs/{orgId}/sites/{siteId}/settings/deviceAccount (standalone)
  "/orgs/:orgId/sites/:siteId/devices/inventoryDeviceAccount.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/devices/inventoryDeviceAccount",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "addDeviceInventoryDeviceAccount",
  },
  // drawer content => setting network
  // API/gluon/organizations => /ents/{entId}/orgs/{orgId}/devices/{deviceId}/settings
  "/ents/:entId/orgs/:orgId/devices/:deviceId/settings.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/devices/:deviceId/settings",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "devicesDrawerContent.initialData.settingsNetwork",
  },
  // API/gluon/organizations => /orgs/{orgId}/devices/{deviceId}/settings (standalone)
  "/orgs/:orgId/devices/:deviceId/settings.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/devices/:deviceId/settings",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "devicesDrawerContent.initialData.settingsNetwork",
  },
  // API/gluon/sites => /ents/{entId}/orgs/{orgId}/sites/{siteId}/devices/{deviceId}/settings
  "/ents/:entId/orgs/:orgId/sites/:siteId/devices/:deviceId/settings.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/devices/:deviceId/settings",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "devicesDrawerContent.initialData.settingsNetwork",
  },
  // API/gluon/sites => /orgs/:orgId/sites/:siteId/devices/:deviceId/settings (standalone)
  "/orgs/:orgId/sites/:siteId/devices/:deviceId/settings.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/devices/:deviceId/settings",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "devicesDrawerContent.initialData.settingsNetwork",
  },
  // Update device settings
  // API/gluon/organizations => /ents/{entId}/orgs/{orgId}/devices/{deviceId}/settings
  "/ents/:entId/orgs/:orgId/devices/:deviceId/settings.update": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/devices/:deviceId/settings",
    restful: true,
    method: "update",
    buildParams: null,
    action: setDrawerDevicesData,
    mockSelector: "devicesDrawerContent.initialData.settingsNetwork",
  },
  // API/gluon/organizations => /orgs/{orgId}/devices/{deviceId}/settings (standalone)
  "/orgs/:orgId/devices/:deviceId/settings.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/devices/:deviceId/settings",
    restful: true,
    method: "update",
    buildParams: null,
    action: setDrawerDevicesData,
    mockSelector: "devicesDrawerContent.initialData.settingsNetwork",
  },
  // API/gluon/sites => /ents/{entId}/orgs/{orgId}/sites/{siteId}/devices/{deviceId}/settings
  "/ents/:entId/orgs/:orgId/sites/:siteId/devices/:deviceId/settings.update": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/devices/:deviceId/settings",
    restful: true,
    method: "update",
    buildParams: null,
    action: setDrawerDevicesData,
    mockSelector: "devicesDrawerContent.initialData.settingsNetwork",
  },
  // API/gluon/sites => /orgs/:orgId/sites/:siteId/devices/:deviceId/settings (standalone)
  "/orgs/:orgId/sites/:siteId/devices/:deviceId/settings.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/devices/:deviceId/settings",
    restful: true,
    method: "update",
    buildParams: null,
    action: setDrawerDevicesData,
    mockSelector: "devicesDrawerContent.initialData.settingsNetwork",
  },
  // API/gluon/sites => /ents/{entId}/orgs/{orgId}/sites/{siteId}/devices/{deviceId}/stats
  "/ents/:entId/orgs/:orgId/sites/:siteId/devices/:deviceId/stats.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/devices/:deviceId/stats",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "devicesDrawerContent.initialData.statistic",
  },
  // API/gluon/sites => /orgs/{orgId}/sites/{siteId}/devices/{deviceId}/stats (standalone)
  "/orgs/:orgId/sites/:siteId/devices/:deviceId/stats.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/devices/:deviceId/stats",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "devicesDrawerContent.initialData.statistic",
  },
  // API/gluon/sites => /ents/{entId}/orgs/{orgId}/sites/{siteId}/devices/{deviceId}/executeCommand
  "/ents/:entId/orgs/:orgId/sites/:siteId/devices/:deviceId/executeCommand.update": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/devices/:deviceId/executeCommand",
    restful: true,
    method: "update",
    buildParams: null,
    action: null,
    mockSelector: "devicesDrawerContent.initialData.executeCommand",
  },
  // API/gluon/sites => /orgs/{orgId}/devices/{deviceId}/executeCommand (standalone)
  "/orgs/:orgId/devices/:deviceId/executeCommand.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/devices/:deviceId/executeCommand",
    restful: true,
    method: "update",
    buildParams: null,
    action: null,
    mockSelector: "devicesDrawerContent.initialData.executeCommand",
  },
  // org create Tunnel access a device
  // API/gluon/organizations => /ents/{entId}/orgs/{orgId}/devices/{deviceId}/tunnelAccess
  "/ents/:entId/orgs/:orgId/devices/:deviceId/tunnelAccess.create": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/devices/:deviceId/tunnelAccess",
    restful: true,
    method: "create",
    buildParams: null,
    action: null,
    mockSelector: "devicesDrawerContent.initialData.tunnelAccess",
  },
  // API/gluon/organizations => /orgs/{orgId}/devices/{deviceId}/tunnelAccess (standalone)
  "/orgs/:orgId/devices/:deviceId/tunnelAccess.create": {
    protocol: "ws",
    resource: "/orgs/:orgId/devices/:deviceId/tunnelAccess",
    restful: true,
    method: "create",
    buildParams: null,
    action: null,
    mockSelector: "devicesDrawerContent.initialData.tunnelAccess",
  },
  // site create Tunnel access a device
  // API/gluon/sites => /ents/{entId}/orgs/{orgId}/sites/{siteId}/devices/{deviceId}/tunnelAccess
  "/ents/:entId/orgs/:orgId/sites/:siteId/devices/:deviceId/tunnelAccess.create": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/devices/:deviceId/tunnelAccess",
    restful: true,
    method: "create",
    buildParams: null,
    action: null,
    mockSelector: "devicesDrawerContent.initialData.tunnelAccess",
  },
  // API/gluon/sites => /orgs/{orgId}/sites/{siteId}/devices/{deviceId}/tunnelAccess (standalone)
  "/orgs/:orgId/sites/:siteId/devices/:deviceId/tunnelAccess.create": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/devices/:deviceId/tunnelAccess",
    restful: true,
    method: "create",
    buildParams: null,
    action: null,
    mockSelector: "devicesDrawerContent.initialData.tunnelAccess",
  },
  // Drawer > Clients
  "/ents/:entId/orgs/:orgId/sites/:siteId/devices/:deviceId/clients.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/devices/:deviceId/clients",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: null,
  },
  "/orgs/:orgId/sites/:siteId/devices/:deviceId/clients.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/devices/:deviceId/clients",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: null,
  },
  // API/gluon/sites =>　/ents/{entId}/orgs/{orgId}/sites/{siteId}/settings/tags/deviceTags
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/tags/deviceTags.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/tags/deviceTags",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "devicesDrawerContent.deviceTag",
  },
  // API/gluon/sites => /orgs/{orgId}/sites/{siteId}/settings/tags/deviceTags (standalone)
  "/orgs/:orgId/sites/:siteId/settings/tags/deviceTags.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/tags/deviceTags",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "devicesDrawerContent.deviceTag",
  },
  // API/gluon/sites =>　/ents/{entId}/orgs/{orgId}/sites/{siteId}/settings/tags/deviceTags
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/tags/deviceTags.create": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/tags/deviceTags",
    restful: true,
    method: "create",
    buildParams: null,
    action: setDeviceTagData,
    mockSelector: "devicesDrawerContent.deviceTag",
  },
  // API/gluon/sites => /orgs/{orgId}/sites/{siteId}/settings/tags/deviceTags (standalone)
  "/orgs/:orgId/sites/:siteId/settings/tags/deviceTags.create": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/tags/deviceTags",
    restful: true,
    method: "create",
    buildParams: null,
    action: setDeviceTagData,
    mockSelector: "devicesDrawerContent.deviceTag",
  },
  // API/gluon/sites =>　/ents/{entId}/orgs/{orgId}/sites/{siteId}/settings/tags/deviceTags
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/tags/deviceTags.update": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/tags/deviceTags",
    restful: true,
    method: "update",
    buildParams: null,
    action:  setEditDeviceTagData,
    mockSelector: "devicesDrawerContent.updateDeviceTag",
  },
  // API/gluon/sites => /orgs/{orgId}/sites/{siteId}/settings/tags/deviceTags (standalone)
  "/orgs/:orgId/sites/:siteId/settings/tags/deviceTags.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/tags/deviceTags",
    restful: true,
    method: "update",
    buildParams: null,
    action:  setEditDeviceTagData,
    mockSelector: "devicesDrawerContent.updateDeviceTag",
  },
  // API/gluon/sites =>　/ents/{entId}/orgs/{orgId}/sites/{siteId}/settings/tags/deviceTags
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/tags/deviceTags.delete": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/tags/deviceTags",
    restful: true,
    method: "delete",
    buildParams: null,
    action: setDeleteDeviceTagData,
    mockSelector: "devicesDrawerContent.updateDeleteDeviceTag",
  },
  // API/gluon/sites => /orgs/{orgId}/sites/{siteId}/settings/tags/deviceTags (standalone)
  "/orgs/:orgId/sites/:siteId/settings/tags/deviceTags.delete": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/tags/deviceTags",
    restful: true,
    method: "delete",
    buildParams: null,
    action: setDeleteDeviceTagData,
    mockSelector: "devicesDrawerContent.updateDeleteDeviceTag",
  },
};

export default devicesConfig;
